<div class="product-gallery">
  <!-- Photo -->
  <div class="product-gallery__photo" tabindex="0" *ngIf="items">
    <swiper [preventClicks]="false" [config]="configMainSlider" (slideChange)="onSlideChange($event)">
      <ng-container *ngFor="let item of items; let i = index">
        <ng-template swiperSlide  >
            <div  (click)="handleShowGallery(i)">
              <img attr.data-src="{{item.url}}" alt="" class="swiper-lazy product-gallery__img">
              <div class="swiper-lazy-preloader"></div>
              <div class="product-gallery__image-red-cover" *ngIf="redCover">{{redCover}}</div>
              <div class="product-gallery__image-text-cover" *ngIf="textCover">{{textCover}}</div>
            </div>
        </ng-template>
      </ng-container>
    </swiper>
    <ng-container *ngIf="items.length > 1">
      <button class="product-gallery__button product-gallery__button-prev">
      </button>
      <button class="product-gallery__button product-gallery__button-next">
      </button>
    </ng-container>
    <span class="product-gallery__counter">{{activeIndex + 1}} / {{items.length}}</span>
  </div>

  <!-- Thumb list-->
  <div class="product-gallery__thumb-carousel" #thumbList>
    <ng-container *ngIf="galleryItemsCount > 0 && items.length > 1">
      <swiper [preventClicks]="false" [config]="configCarousel" [slidesPerView]="galleryItemsCount" [slidesPerGroup]="galleryItemsCount" [loop]="galleryItemsCount < items.length">
        <ng-container *ngFor="let item of items; let i = index">
          <ng-template swiperSlide>
            <span class="carousel-cell product-gallery__thumb" [class.product-gallery__thumb_360]="item.is360view" [class.product-gallery__thumb_video]="item.type === 'video'" (click)="handleShowGallery(i)">
              <img [src]="item.reduced" alt="" class="product-gallery__img" (mousedown)="false">
            </span>
          </ng-template>
        </ng-container>
      </swiper>

      <div class="product-gallery__carousel-prev"></div>
      <div class="product-gallery__carousel-next"></div>
    </ng-container>
  </div>

  <div class="product-gallery__thumb-list" *ngIf="items.length > 1">
    <!-- Thumb -->
    <ng-container *ngFor="let item of items; let i = index">
      <span class="carousel-cell product-gallery__thumb product-gallery__thumb_regular" [class.product-gallery__thumb_360]="item.is360view" [class.product-gallery__thumb_video]="item.type === 'video'" (click)="handleShowGallery(i)">
        <img [src]="item.reduced" alt="" class="product-gallery__img" (mousedown)="false">
      </span>
    </ng-container>
  </div>
</div>